<template>
  <div class="w-100vw bg-white mt-10">
    <ul class="grid grid-cols-4 gap-12 p-12 h-full">
      <li
        v-for="option in mediaOptions"
        :key="option.src"
        class="bg-#F7F7F7 rounded-14 pb-full h-0 relative"
      >
        <div
          class="flex flex-col items-center justify-center size-full absolute inset-0"
        >
          <Image
            v-model="fileList"
            :preview-image="false"
            v-bind="option.mediaType === 'camera' ? { capture: 'camera' } : {}"
            class="size-full [&_.van-uploader\_\_wrapper,&_.van-uploader\_\_input-wrapper]:size-full [&_.van-uploader\_\_wrapper,&_.van-uploader\_\_input-wrapper]:flex [&_.van-uploader\_\_wrapper,&_.van-uploader\_\_input-wrapper]:flex-col [&_.van-uploader\_\_wrapper,&_.van-uploader\_\_input-wrapper]:items-center [&_.van-uploader\_\_wrapper,&_.van-uploader\_\_input-wrapper]:justify-center"
          >
            <img :src="option.src" alt="icon" class="w-26 h-24" />
            <span class="font-600 text-14 text-black mt-10">{{
              option.label
            }}</span>
          </Image>
        </div>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import CameraImg from "@/assets/images/ai-chat/media-camera.png";
import GalleryImg from "@/assets/images/ai-chat/media-gallery.png";
import Image from "./Image.vue";
import { useI18n } from "vue-i18n";
const fileList = defineModel<{ url: string }[]>({
  default: [],
});

interface MediaOption {
  label: string;
  src: string;
  mediaType: "camera" | "gallery" | "image";
}

const { t } = useI18n();
const mediaOptions = ref<MediaOption[]>([
  {
    label: t("message.ai.Camera"),
    src: CameraImg,
    mediaType: "camera",
  },
  {
    label: t("message.ai.Photo"),
    src: GalleryImg,
    mediaType: "gallery",
  },
]);
</script>
